/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".help{position:absolute;text-align:justify;-webkit-transition:opacity 2s ease-out;transition:opacity 2s ease-out;opacity:1;width:200px;right:20px;background-color:#fff;border:1px solid #122f4c;box-shadow:0 0 20px 0 rgba(0,0,0,.2),0 5px 5px 0 rgba(0,0,0,.24);font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:80%;text-justify:inter-word;z-index:1000}.help .help-body{padding:4px;line-height:1.6}.help .help-title{padding:10px;font-weight:700;border-bottom:1px solid #122f4c}.help .search{padding:10px}"];
export { styles as styles };
